import React, { useState } from "react";
import { useUser } from "@dreamchimney/user-context";
import { getSleeveIsFavorite, setSleeveIsFavorite } from "../../api/getSleeves";
import { axiosAuth } from "@dreamchimney/react-axios";

const FavoriteIcon = ({ className = "", sleeveId, userFav = false, showDescription = false }) => {
  const [fav, setFav] = useState(userFav);
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(true);
  // const [count, setCount] = useState(parseInt(track.favs) || 0);
  const { state: userState, dispatch } = useUser();

  React.useEffect(() => {
    if (!sleeveId || !userState.loggedin) {
      setLoading(false);
      return;
    }
    setLoading(false);
    getSleeveIsFavorite(axiosAuth, sleeveId).then(({ data: { favorite } }) => {
      // setCount(total);
      setFav(favorite);
    });
  }, [userState.user]);

  React.useEffect(() => {
    if (sleeveId && userState.loaded) {
      setReady(true);
      return;
    }
  }, [userState.loaded]);

  const toggleFav = () => {
    if (ready && !userState.loggedin && sleeveId) {
      localStorage.setItem("login_sleeve_fav", sleeveId);
      dispatch({ type: "signin_show_fav" });
      // faked since we cant set these values after login/register
      // setCount(parseInt(count) + 1);
      setFav(true);
      return;
    }

    setLoading(true);
    setSleeveIsFavorite(axiosAuth, sleeveId).then(({ data: { favorite } }) => {
      // setCount(total);
      setFav(favorite);
      setLoading(false);
    });
  };

  if (!sleeveId) {
    return null;
  }
  return (
    <span className={className}>
      <span className="icon-wrapper">
        {loading && <i className="fas fa-spinner fa-spin"></i>}
        {!loading && (
          <span
            title={!userState.loggedin ? `Sign-in to add this sleeve to your favorites` : `Add sleeve to favorites`}
            onClick={() => toggleFav()}
          >
            {fav && <i className="fas fa-heart"></i>}
            {!fav && <i className="far fa-heart"></i>}
            {/* <span className="counter">0</span> */}
            {showDescription && <span className="description">Add to Favorites</span>}
          </span>
        )}
      </span>
    </span>
  );
};

export default FavoriteIcon;
